import React from 'react'
import {connect} from 'react-redux'

import '../../asset/less/component.css'
import '../../asset/less/Showcase.css'

import {Button, Card, Col, Empty, message, Modal, Popconfirm, Row, Skeleton, Spin} from 'antd'
import {DeleteOutlined, EditOutlined, SelectOutlined} from '@ant-design/icons'

import MediaForm from '../../component/showcase/MediaForm'
import {getArtistProfile} from '../../api/artistProfiles'
import {deleteArtistMedia, getArtistMedia, postArtistMedia, putArtistMedia} from '../../api/artistMedias'
import {uploadImage} from '../../api/amazonS3'
import {validateMessages} from '../../app/util'
import Title from 'antd/es/typography/Title'
import Meta from 'antd/es/card/Meta'
import HttpError from '../../component/base/HttpError'
import {getValidYearDisplay} from '../../component/Utils'
import {URL_SHOWCASE_ARTWORK} from "../../const";
import BackButton from "../../component/base/BackButton";
import {withRouter} from "react-router";
import {is_admin_user} from "../../app/role";

const {confirm} = Modal

@connect((state) => ({
    //decorator, gives component access to the state
    id: state.user.info.id,
    userId: state.user.info.userId,
    email: state.user.info.email,
    artistId: state.user.info.artistId,
    role: state.user.info.role
}))
class ShowcaseMedia extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            saveLoading: false,
            modalIsVisible: false, //This is for the Media Edit/Add Form
            media: [], //the actual media objects {id, title, etc.}
            changedMedia: {}, //the media being added or edited
            toAdd: true, //to Add or to Edit (will be false if we want to edit a media instead of add)
            mediaRows: [], //this will be an array of arrays to display the rows/columns of media
            deletePopconfirmVisible: false
        }
    }

    componentDidMount() {
        if (!this.props.artistId) return
        this.setState({loading: true})
        getArtistProfile(this.props.artistId) //returns Promise
            .then((responseProfile) => {
                const artistMedias = responseProfile.data.media
                const mediaPromises = []
                for (const m of artistMedias) {
                    mediaPromises.push(getArtistMedia(m))
                }
                Promise.all(mediaPromises)
                    .then((responses) => {
                        this.setState({
                            media: responses.map((responses) => (responses.data))
                        })
                    })
                    .catch((error) => {
                        HttpError(error)
                    })
            })
            .catch((error) => {
                HttpError(error)
            })
            .finally(() => {
                this.setState({loading: false})
            })
    }

    addMediaHandler = () => {
        this.setState({
            modalIsVisible: true,
            changedMedia: {},
            toAdd: true
        })
    }

    editMediaHandler = (media) => {
        this.setState({
            modalIsVisible: true,
            changedMedia: media,
            toAdd: false
        })
    }

    deleteMediaHandler = (media) => {
        // shows the confirmation box, then deletes accordingly
        let artist_id = this.props.artistId
        let is_admin = is_admin_user(this.props)
        this.setState({
            saveLoading: true
        })
        deleteArtistMedia(media.id, is_admin, artist_id)
            .then(() => {
                const rest = this.state.media.filter((mediaItem) => (mediaItem.id !== media.id))
                this.setState({
                    media: [
                        ...rest
                    ]
                })
            })
            .catch(() => {
                message.error('Could not delete').then(() => {
                })
            }).finally(() => {
            this.setState({
                saveLoading: false
            })
        })
    }

    onSubmit = (values) => {
        const getValidYear = (year) => {
            try {
                return parseInt(year)
            } catch (e) {
                return -1
            }
        }
        const {title, subtitle, description, thumbnails, location, year, end_year, link} = values
        const media = {
            title: title,
            subtitle: subtitle,
            desc: description,
            thumbnails: (thumbnails && thumbnails.length > 0) ? (thumbnails[0].response !== undefined ?
                thumbnails[0].response.s3_url : thumbnails[0].thumbUrl) : '',
            location,
            year: getValidYear(year),
            end_year: getValidYear(end_year),
            link
        }
        this.setState({
            saveLoading: true
        })
        if (this.state.toAdd) {
            let request
            request = postArtistMedia({
                artist_id: this.props.artistId,
                ...media
            })
            request
                .then((res) => {
                    message.success('Added successfully').then(() => {
                    })
                    this.setState({
                        media: [
                            ...this.state.media,
                            res.data
                        ]
                    })
                })
                .catch((error) => {
                    HttpError(error)
                }).finally(() => {
                this.setState({
                    saveLoading: false
                })
            })
        } else {
            let request
            request = putArtistMedia(this.state.changedMedia.id, {
                artist_id: this.props.artistId,
                ...media
            })
            request
                .then(() => {
                    message.success('Edited successfully').then(() => {
                    })
                    const rest = this.state.media.filter((mediaItem) => (mediaItem.id !== this.state.changedMedia.id))
                    this.setState({
                        media: [
                            {
                                id: this.state.changedMedia.id,
                                ...media
                            },
                            ...rest
                        ]
                    })
                })
                .catch((error) => {
                    HttpError(error)
                }).finally(() => {
                this.setState({
                    saveLoading: false,
                    changedMedia: null
                })
            })
        }
        this.setState({
            modalIsVisible: false,
        })
    }

    customRequest = (options) => {
        //this occurs on upload, not submit
        const {onError, onSuccess, file, onProgress} = options
        uploadImage(this.props.email, file, onSuccess, onError, onProgress)
    }

    handleCancel = () => {
        //cancelling the modal form for add/edit
        this.setState({
            modalIsVisible: false,
            changedMedia: null
        })
    }

    getLinkUrl = (url) => {
        if (!url) return ""
        if (url.startsWith("http://") || url.startsWith("https://")) {
            return url
        }
        return "https://" + url
    }

    render() {
        const getYearDisplay = (m) => {
            const year = getValidYearDisplay(m.year)
            const end_year = getValidYearDisplay(m.end_year)
            const layout = []
            if (year && end_year) {
                layout.push("from " + year + ' to ' + end_year + ",")
            } else if (year) {
                layout.push("in " + year + ",")
            }
            if (m.location) {
                layout.push(" at " + m.location)
            }
            return (
                <p style={{whiteSpace: 'pre-line', wordBreak: 'break-all'}}>
                    {layout} <br/> {m.desc}
                </p>
            )
        }

        const getActions = (m) => {
            let actions = []
            let editAction = (<EditOutlined
                key={'edit' + m.id}
                style={{color: '#0531ad'}}
                onClick={(event) => {
                    if (!this.state.loading) {
                        this.editMediaHandler(m)
                    }
                }}
            />)
            let deleteAction = (
                <Popconfirm
                    key={m.id}
                    title='Are you sure you want to permanently delete it?'
                    onConfirm={() => this.deleteMediaHandler(m)}
                    onCancel={() => {
                        this.setState({
                            deletePopconfirmVisible: false
                        })
                    }}
                >
                    <DeleteOutlined
                        style={{marginLeft: 6, color: 'indianred'}}
                        onClick={() => {
                            this.setState({
                                deletePopconfirmVisible: true
                            })
                        }}
                    />
                </Popconfirm>
            )

            actions.push(editAction)

            if (m.link) {
                actions.push(
                    <a href={this.getLinkUrl(m.link)} target={'_blank'} rel={'noreferrer'}>
                        <SelectOutlined
                            key={'view' + m.id}
                            style={{color: '#0531ad'}}
                        >
                        </SelectOutlined>
                    </a>
                )
            }

            actions.push(deleteAction)

            return actions
        }

        return (
            <Spin size={'small'} spinning={this.state.saveLoading}>
                <div className='site-layout-background'>
                    <Row align='baseline' gutter={{xs: 8, sm: 16, md: 24}}
                         style={{marginTop: 12, justifyContent: "space-between"}}>
                        <Col style={{display: 'table', textAlign: "center", height: '100%'}}>
                            <Title level={1} style={{
                                marginBottom: 12,
                                marginTop: 12
                            }}>News</Title>
                        </Col>
                        <Col style={{display: 'table', textAlign: "center", height: '100%'}}>
                            {!this.state.loading && (
                                <Button
                                    style={{marginTop: 12, marginBottom: 12, marginRight: 24}}
                                    type={'primary'}
                                    size='large'
                                    onClick={this.addMediaHandler}
                                >
                                    Click here to add
                                </Button>
                            )}
                        </Col>
                    </Row>
                    <p>
                        <i>
                            List your previous collaborations, exhibitions, publications, and recent news here.{' '}
                            <a style={{color: 'black', textDecoration: 'underline'}}
                               href={'https://revart.co/sam/faqs/2.-Manage+The+Showcase'}>
                                Learn More
                            </a>
                            .
                        </i>
                    </p>
                    <Row style={{minHeight: this.state.media.length > 0 ? '80vh' : null}}
                         gutter={{xs: 8, sm: 16, md: 24}}>
                        {this.state.loading && (
                            <>
                                <Skeleton active/>
                                <Skeleton active/>
                                <Skeleton active/>
                                <Skeleton active/>
                                <Skeleton active/>
                            </>
                        )}
                        {this.state.media.map((m) => (
                            <Col key={m.id} xs={24} sm={11} md={11} lg={11} xl={7}>
                                <Card
                                    cover={m.thumbnails && (<img src={m.thumbnails} alt={m.title} height={320} style={{
                                        objectFit: 'cover'
                                    }}/>)}
                                    actions={getActions(m)}
                                >
                                    <Row justify='space-between' align='middle'>
                                        <Meta
                                            title={
                                                <Title level={3}
                                                       style={{
                                                           whiteSpace: 'pre-line', wordBreak: 'break-all', height: 64,
                                                           overflowY: 'hidden', textOverflow: 'ellipsis'
                                                       }}>
                                                    {m.title}
                                                </Title>
                                            }
                                            description={
                                                <div style={{height: 240, overflowY: 'auto'}}>
                                                    <h4 style={{
                                                        whiteSpace: 'pre-line',
                                                        wordBreak: 'break-all'
                                                    }}>{m.subtitle}</h4>
                                                    {getYearDisplay(m)}
                                                </div>
                                            }
                                        ></Meta>
                                    </Row>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                    <p/>
                    {this.state.media.length === 0 && !this.state.loading && <Empty style={{margin: 24}}/>}
                    {this.state.media.length > 0 && (
                        <div style={{display: 'flex'}}>
                            <Button type='primary' onClick={this.addMediaHandler} block
                                    style={{width: 'auto', marginLeft: 'auto', marginRight: 'auto'}}>
                                {this.state.media.length === 0 && 'Click here to add'}
                                {this.state.media.length !== 0 && 'Click here to add more'}
                            </Button>
                        </div>
                    )}
                    <MediaForm
                        visible={this.state.modalIsVisible}
                        validateMessages={validateMessages}
                        onSubmit={this.onSubmit}
                        onCancel={this.handleCancel}
                        media={this.state.changedMedia}
                        customRequest={this.customRequest}
                    />
                    <Row gutter={[32, 16]} style={{
                        backgroundColor: 'rgba(255,255,255,0.4)',
                        position: 'fixed',
                        zIndex: 1000,
                        paddingLeft: 12,
                        paddingRight: 12,
                        justifyContent: 'space-evenly',
                        justifyItems: 'center',
                        left: this.props.siderWidth,
                        width: '90%',
                        bottom: 12,
                        alignItems: 'center',
                        flexDirection: "row"
                    }}>
                        <Col xs={12} sm={5} md={5} lg={3}>
                            <BackButton {...this.props} block/>
                        </Col>
                        <Col xs={12} sm={6} md={5} lg={4}>
                            <Button
                                onClick={(e) => {
                                    window.location.href = URL_SHOWCASE_ARTWORK
                                }}
                                block
                                type='primary'
                                size='middle'
                                htmlType='submit'
                                style={{float: "right"}}
                            >
                                Continue
                            </Button>
                        </Col>
                    </Row>

                </div>
            </Spin>
        )
    }
}

export default withRouter(ShowcaseMedia)
